<template>
  <page-article>
    <div class="col-12 page_content_area">
      <div class="container">
        <recruitment-orientation-time-slots
          :orientations="currentOrientationDetailsGetter"
          read-only
        />
      </div>
    </div>
  </page-article>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
import RecruitmentOrientationTimeSlots from './common/RecruitmentOrientationTimeSlots'

export default {
  name: 'RecruitmentOrientationDetailsContent',
  components: {
    pageArticle,
    RecruitmentOrientationTimeSlots
  },
  computed: {
    ...mapGetters('pages/campus-recruiting', [
      'currentOrientationInfoGetter',
      'currentOrientationDetailsGetter'
    ])
  },
  async created () {
	try {
		await this.getOrientationsDetailsById(this.$route.params.id);
	} catch (err) {
		this.$router.push('/campus-recruiting');
	}
  },
  methods: {
    ...mapActions('pages/campus-recruiting', [
      'getOrientationsDetailsById'
    ])
  }
}
</script>
